import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { useHasPermission } from '../hooks';
import { Tags } from '../interfaces';
import { TagsService } from '../services';

export const useTagsQuery = (enabled = true) => {
  const queryKey = ['tags'];
  const hasPermission = useHasPermission('tags:read:list');

  const queryFn = () => TagsService.getAvailableTags();

  return useQuery({
    queryKey,
    queryFn,
    enabled: hasPermission && enabled,
  });
};

export const useEventTags = (eventId: number, enabled = true) => {
  const queryKey = ['tags', 'event', eventId];
  const hasTagsPermission = useHasPermission('tags:read:list');
  const hasEventPermission = useHasPermission('events:read:tags');
  const hasPermission = hasTagsPermission && hasEventPermission;

  const queryFn = () => TagsService.getTagsForEvent(eventId);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!eventId && hasPermission && enabled,
  });
};

export const invalidateTagsQuery = () => {
  // Make sure we refetch the event in the background, WHEN NEEDED - but display
  // the cached data in the meantime, instantenously
  queryClient.invalidateQueries(['tags']);
};

export const invalidateEventTagsQuery = (eventId: number, tags: Tags) => {
  // Put data (or partial data) into cache
  queryClient.setQueryData(['tags', 'event', eventId], tags);

  // Make sure we refetch the event in the background, WHEN NEEDED - but display
  // the cached data in the meantime, instantenously
  queryClient.invalidateQueries(['tags', 'event', eventId]);
};
